import { ReactComponent as LoaderIcon } from "./../images/svg/loader.svg";
import React from "react";

const Loader = ({ message }) => {
  return (
    <div id="object-preloader id-loading" className="object-preloader">
      <div className="object-preloader--content">
        <LoaderIcon className="loader" />
        <br />
        <small>{message}</small>
      </div>
    </div>
  );
};

export default Loader;
